//-----------------------
// load combatant values
//-----------------------
export default function loadCombatantValues(existing_combatant) {
  let combatant = {
    seq: existing_combatant.seq,
    id: existing_combatant.id,
    name: existing_combatant.name,
    slug: existing_combatant.slug,
    player: existing_combatant.player_name,
    player_id: existing_combatant.player,
    race: existing_combatant.race_name,
    category: existing_combatant.category,
    type: existing_combatant.type,
    role: existing_combatant.role,
    status: existing_combatant.status,
    sub_status: existing_combatant.sub_status,
    ca: existing_combatant.ca,
    cr: existing_combatant.cr,
    dex: existing_combatant.dex,
    sr: existing_combatant.sr,
    damage_mod: existing_combatant.damage_mod,
    sr_roll: existing_combatant.sr_roll,
    sr_adj: existing_combatant.sr_adj,
    roll_off: existing_combatant.roll_off,
    second_weapon: existing_combatant.second_weapon,
    shield: existing_combatant.shield,
    ranged: existing_combatant.ranged,
    magic: existing_combatant.magic,
    special_action: existing_combatant.special_action,
    special_reaction: existing_combatant.special_reaction,
    image: existing_combatant.image,
  }
  return combatant
}
